module.exports = __webpack_public_path__ + "static/media/hero-carros.7d2ef4a0.webp";